﻿import OrderFilmApi, { LinkInfo } from '../../OrderFilmApi';

export function getSentLinks(orderId: number): Promise<LinkInfo[]> {
    return OrderFilmApi.getOrderFilmLinks(orderId);
}
